module.exports = __webpack_public_path__ + "assets/kosher-db1800.svg";